import { KYC_REVIEW_STATUS } from "./constants";

export function getKycReviewActions(status) {
  const map = {
    [KYC_REVIEW_STATUS.PENDING]: [
      { label: "Mark under review", target: KYC_REVIEW_STATUS.UNDER_REVIEW, variant: "outline" },
      { label: "Approve", target: KYC_REVIEW_STATUS.APPROVED, variant: "success" },
      { label: "Reject", action: "reject", variant: "danger" },
    ],
    [KYC_REVIEW_STATUS.UNDER_REVIEW]: [
      { label: "Approve", target: KYC_REVIEW_STATUS.APPROVED, variant: "success" },
      { label: "Request resubmission", action: "resubmit", variant: "outline" },
      { label: "Reject", action: "reject", variant: "danger" },
    ],
    [KYC_REVIEW_STATUS.RESUBMISSION_REQUIRED]: [
      { label: "Mark under review", target: KYC_REVIEW_STATUS.UNDER_REVIEW, variant: "outline" },
    ],
    [KYC_REVIEW_STATUS.APPROVED]: [],
    [KYC_REVIEW_STATUS.REJECTED]: [
      { label: "Request resubmission", action: "resubmit", variant: "outline" },
    ],
  };
  return map[status] || map[KYC_REVIEW_STATUS.PENDING];
}
